import { render, staticRenderFns } from "./DetalleCambioNiveles.vue?vue&type=template&id=56b34f52&"
import script from "./DetalleCambioNiveles.vue?vue&type=script&lang=js&"
export * from "./DetalleCambioNiveles.vue?vue&type=script&lang=js&"
import style0 from "./DetalleCambioNiveles.vue?vue&type=style&index=0&id=56b34f52&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports